var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex align-center justify-center",attrs:{"fluid":"","fill-height":""}},[_c('AntLoading')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }